import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $id: String!
    $data: PesticideUpdateInput!
  ) {
    updateOnePesticide(
      where: { id: $id }
      data: $data
    ) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Fitofármaco actualizado`, mutationTypes.UPDATE)
)

